import { useEffect, useState } from 'react';

import { getTempInfoCountryConfig } from '../constants/countries';
import { LDFlags } from '../constants/flags';
import { isTreatedAsOther } from '../constants/lienholders';
import { usePayoffIntelligence } from './useAutoFetchPayoff/usePayoffIntelligence';
import { useLazyFlag } from './useLazyFlag';
import { useTempInfo } from './useTempInfo';

export const useSkipPayoffAccordion = () => {
  const { info } = useTempInfo({ fetchPolicy: 'network-only' });
  const evaluate = useLazyFlag();
  const { checkLienholderSupportedForPI } = usePayoffIntelligence();
  const tempInfoData = info?.data;
  const { payoffCollection } = getTempInfoCountryConfig(tempInfoData);

  const [skipPayoffAccordion, setSkipPayoffAccordion] = useState(false);

  useEffect(() => {
    const checkSkipValue = async () => {
      if (!payoffCollection) {
        return;
      }

      const { isSupported } = await checkLienholderSupportedForPI();

      const forceShowPayoffPage = isTreatedAsOther(tempInfoData);

      setSkipPayoffAccordion(
        ((evaluate(LDFlags.COM_HIDE_PAYOFF_PAGE) || isSupported) && !forceShowPayoffPage) ||
          (tempInfoData?.automatically_fetched_payoff ?? false),
      );
    };
    checkSkipValue();
  }, [
    tempInfoData?.automatically_fetched_payoff,
    tempInfoData?.lienholder_slug,
    tempInfoData?.lienholder,
    payoffCollection,
    checkLienholderSupportedForPI,
    evaluate,
  ]);

  return !payoffCollection || skipPayoffAccordion;
};
